import React, { useState, useEffect, useMemo } from "react";
import ServerStatusModal from "../../Components/ServerStatus/ServerStatusModal.module.tsx";
import { toPersian } from "../../Utility/Utilities.js";
import styles from "./ServerStatus.module.css";
import IrluxStatusSvg from "../../Components/ServerStatus/IrluxStatusSvg.tsx";
import { useFetchWithToken } from "../../Components/FetchWithToken/FetchWithToken.js";
import { apiUrl } from "../../Constants/Constants.js";
import { toast } from "react-toastify";
import { AuthContext } from "../../Constants/AuthProvider.js";
import BackButton from "../../Components/BackButton/BackButton.module.js";

const ServerStatus = () => {
  const { loading, fetchWithToken } = useFetchWithToken();
  const { onLogout } = React.useContext(AuthContext);
  const [protocols, setProtocols] = useState([]);

  const fetchServerStatus = () => {
    fetchWithToken(apiUrl + "server/server-status", { method: "GET" }).then(
      (data) => {
        if (data.status === "200") {
          const next = Array.isArray(data.data) ? data.data : [];
          // فقط وقتی ست کن که واقعاً تغییر کرده
          setProtocols((prev) => {
            const same = JSON.stringify(prev) === JSON.stringify(next);
            return same ? prev : next;
          });
        } else if (data.status === "6") {
          toast.error(data.data);
        } else if (data.status === "401") {
          onLogout();
        }
      }
    );
  };

  useEffect(() => {
    fetchServerStatus();
    const id = setInterval(fetchServerStatus, 10000);
    return () => clearInterval(id); // مهم: پاکسازی اینتروال
  }, []);

  // فرزند با memo تا وقتی پراپ‌ها تغییر واقعی نکنن رندر نشه
  const EachCountry = React.memo(
    ({ protocol }) => {
      // این دو آبجکت هر رندر جدید ساخته نشن
      const ping = useMemo(
        () => ({
          middleToForeign: protocol.ServerTunnelPing,
          middleToProton: protocol.ProtonPing,
          clientToMiddleICMP: 0,
        }),
        [protocol.ServerTunnelPing, protocol.ProtonPing]
      );

      const status = useMemo(
        () => ({
          middle: "up",
          foreign: protocol.ServerTunnelStatus,
          proton: protocol.ProtonStatus,
        }),
        [protocol.ServerTunnelStatus, protocol.ProtonStatus]
      );

      return (
        <IrluxStatusSvg
          ping={ping}
          status={status}
          country={protocol.ProtocolName}
        />
      );
    },
    (prev, next) =>
      prev.protocol.ServerTunnelPing === next.protocol.ServerTunnelPing &&
      prev.protocol.ProtonPing === next.protocol.ProtonPing &&
      prev.protocol.ServerTunnelStatus === next.protocol.ServerTunnelStatus &&
      prev.protocol.ProtonStatus === next.protocol.ProtonStatus &&
      prev.protocol.ProtocolName === next.protocol.ProtocolName
  );

  const EachServer = React.memo(
    ({ server }) => {
      return (
        <>
          <div className={styles.serverTitle}>
            وضعیت سرور تهران {toPersian(server.serverId)}
          </div>

          {server?.MainProtocols?.map((protocol) => (
            <EachCountry
              protocol={protocol}
              key={`${server.serverId}-${protocol.ProtocolName}`}
            />
          ))}
        </>
      );
    },
    (prev, next) =>
      prev.server.serverId === next.server.serverId &&
      JSON.stringify(
        prev.server.MainProtocols?.map((p) => [
          p.ProtocolName,
          p.ServerTunnelPing,
          p.ProtonPing,
          p.ServerTunnelStatus,
          p.ProtonStatus,
        ])
      ) ===
        JSON.stringify(
          next.server.MainProtocols?.map((p) => [
            p.ProtocolName,
            p.ServerTunnelPing,
            p.ProtonPing,
            p.ServerTunnelStatus,
            p.ProtonStatus,
          ])
        )
  );

  return (
    <>
      <BackButton />
      <div className={styles.serverStatusPart}>
        <div className={styles.serverStatusTitle}>
          <i className="fas fa-server"></i>
          وضعیت سیستم مدیریت گیت وی هوشمند ایرلوکس
        </div>
        <div className={styles.descer}>
          <i className="fa-light fa-exclamation-circle"></i>
          سیستم به‌صورت خودکار مسیر اتصال شما از داخل کشور تا سرورهای خارجی و
          همچنین مسیر پشتیبان را بررسی کرده و نتیجه را به شکل تصویری نمایش
          می‌دهد.
          <br />
          اطلاعاتی که در این نمودار مشاهده می‌کنید شامل سلامت سرورها، کیفیت و
          پایداری ارتباط و همچنین زمان پاسخ (پینگ) میان نقاط مختلف شبکه است. به
          این ترتیب می‌توانید در هر لحظه از وضعیت سرویس خود آگاه باشید و اطمینان
          داشته باشید که اتصال شما از بهترین مسیر و با بالاترین کیفیت در حال
          برقرار شدن است.
          <br />
          در صورت قطع شدن هر اتصال، سرویس هوشمند ایرلوکس به سرعت مراتب را جهت
          برقراری مجدد اتصال انجام خواهد داد.
        </div>
      </div>
      {protocols?.length > 0 &&
        protocols.map((server) => <EachServer server={server} key={1} />)}
    </>
  );
};

export default ServerStatus;
